{
  "srTitle": "Anti Human Safari Project — protezione dai droni per i civili di Kherson, Ucraina",
  "logoAlt": "Logo del progetto Anti Human Safari",
  "intro": "Forniamo attrezzature di protezione contro gli attacchi di piccoli droni a volontari, servizi di emergenza e lavoratori delle infrastrutture critiche a Kherson, in Ucraina.",
  "safari": "Dall'estate del 2024 i civili di Kherson sono sistematicamente braccati dall'esercito russo con droni video, in una campagna di terrore nota come «Human Safari».",
  "unLink": "La Commissione ONU riconosce lo Human Safari come crimine di guerra",
  "donateNow": "Dona ora",
  "donateMonthly": "Dona mensilmente",
  "otherWays": "altri modi per donare",
  "instagram": "Instagram",
  "pastFundraisers": "Raccolte fondi precedenti:",
  "fundraiser2025": "Raccolta fondi 2025",
  "donateVia": "Dona tramite:",
  "charityRef": "tramite un ente benefico del Regno Unito, con causale:",
  "germanCharityRef": "tramite un ente benefico tedesco, con causale:",
  "copy": "Copia",
  "copied": "Copiato!",
  "close": "Chiudi",
  "viewMedia": "Guarda il contenuto",
  "andrushenkoCredit": "Oleksandr Andrushenko, fotoreporter della testata Vgoru",
  "fruitSellerDescription": "Un venditore di frutta inseguito da un drone a fibra ottica",
  "khersonPoliceCredit": "da @khersonpolice",
  "firefighterDescription": "Un vigile del fuoco spegne un'auto dopo un attacco dell'«Human Safari», dietro giace una vittima",
  "previousMedia": "Precedente",
  "nextMedia": "Successivo",
  "fpvDroneDescription": "Drone FPV a caccia durante l'«Human Safari»",
  "busAttackDescription": "Uno dei tanti attacchi con droni FPV contro i mezzi pubblici",
  "notFoundTitle": "Pagina non trovata",
  "notFoundMessage": "Questa pagina non esiste. Potrebbe essere stata spostata o il link potrebbe essere errato.",
  "backHome": "Torna alla home",
  "droneDetectorDescription": "I rilevatori di droni sono piccoli dispositivi portatili che avvisano se un drone è vicino",
  "vestDescription": "Giubbotti protettivi leggeri possono ridurre la gravità delle ferite causate da un attacco di droni"
}
